export default "<div class=\"header\">\n    <app-list-header></app-list-header>\n</div>\n<div>\n    about us\n</div>";